import React, { useState } from 'react';
import { Flex, Button } from 'antd';
import { Title, Text } from 'components/Base/Typography';
import { useGetReportMetadataQuery } from 'redux/apiSlice/reporting.slice';
import { PreparedReports } from 'assets/icon/icon';
import { SCard } from './ReportCard.styles';
import DownloadReportModal from './DownloadReportModal/DownloadReportModal';

interface ReportCardProps {
  name: string;
}

const ReportCard: React.FC<ReportCardProps> = ({ name }) => {
  const { data: metadata } = useGetReportMetadataQuery();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <SCard data-cy="report-card">
        <Flex vertical className="w-100 h-100" justify="center">
          <Flex vertical>
            <Title
              level={2}
              data-cy="report-card-title"
              style={{ marginBottom: 24 }}
            >
              {name}
            </Title>

            <Flex align="center" justify="space-between">
              <Flex vertical style={{ flex: 1 }}>
                <Title
                  level={4}
                  data-cy="report-card-header"
                  style={{ marginBottom: 8 }}
                >
                  Find Your Most Commonly Used Reports — Ready When You Are
                </Title>
                <Text data-cy="report-card-item-description">
                  Access quarterly reports, answers to frequently asked
                  questions, and key operational insights—all in one place.
                  Download either the summary report for a quick overview or the
                  full dataset to explore in Excel at your own pace.
                </Text>
              </Flex>

              <Flex align="center" justify="center" style={{ flex: 1 }}>
                <PreparedReports size={129} />
              </Flex>
            </Flex>
          </Flex>

          <Flex justify="flex-start" style={{ marginTop: 24 }}>
            <Button
              type="primary"
              size="large"
              onClick={handleOpenModal}
              data-cy="report-card-choose-button"
            >
              Choose Report
            </Button>
          </Flex>
        </Flex>
      </SCard>

      <DownloadReportModal
        open={isModalOpen}
        onCancel={handleCloseModal}
        data={metadata}
      />
    </>
  );
};

export default ReportCard;
